import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { appUrl } from 'environments/environment.base';

@Component({
    selector: 'app-content-header',
    templateUrl: './content-header.component.html',
    styleUrls: ['./content-header.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class ContentHeaderComponent implements OnInit {
    @Input()
    title: string;

    @Input()
    breadcrumb: any[];

    constructor() {}

    ngOnInit(): void {
        this.breadcrumb = this.breadcrumb.map((value) => {
            let appCompleteUrl = appUrl;
            if (appUrl.includes('localhost')) {
                appCompleteUrl += ':4200';
            }
            return {
                ...value,
                route: value.route ? new URL(value.route, appCompleteUrl) : undefined
            };
        });
    }
}
